import React from 'react';
import PropTypes from 'prop-types';

// Main large curved sparkle - matches sparkle-1.svg exactly
export const SparkleMain = ({ className, style }) => (
  <svg
    className={className}
    fill="none"
    height="100%"
    overflow="visible"
    preserveAspectRatio="none"
    style={{ display: 'block', ...style }}
    viewBox="0 0 17 17"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 2147205512">
      <path
        d="M17 8.5H15.7857C11.7619 8.5 8.5 11.7619 8.5 15.7857V17"
        id="Ellipse 22119"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M8.5 17L8.5 15.7857C8.5 11.7619 5.23808 8.5 1.21429 8.5L4.10923e-07 8.5"
        id="Ellipse 22120"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M-8.62303e-07 8.5L1.21428 8.5C5.23807 8.5 8.5 5.23807 8.5 1.21429L8.5 0"
        id="Ellipse 22121"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M8.5 -1.23385e-06L8.5 1.21428C8.5 5.23807 11.7619 8.5 15.7857 8.5L17 8.5"
        id="Ellipse 22122"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

SparkleMain.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

SparkleMain.defaultProps = {
  className: '',
  style: {},
};

// Curved sparkle with 4 curved paths - matches original SVG exactly
export const SparkleCurved = ({ className, style }) => (
  <svg
    className={className}
    fill="none"
    height="100%"
    overflow="visible"
    preserveAspectRatio="none"
    style={{ display: 'block', ...style }}
    viewBox="0 0 9 9"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 2147205513">
      <path
        d="M9 4.5H8.35714C6.2269 4.5 4.5 6.2269 4.5 8.35714V9"
        id="Ellipse 22119"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M4.5 9L4.5 8.35714C4.5 6.2269 2.7731 4.5 0.642857 4.5L2.17547e-07 4.5"
        id="Ellipse 22120"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M-3.33798e-07 4.5L0.642857 4.5C2.7731 4.5 4.5 2.7731 4.5 0.642857L4.5 0"
        id="Ellipse 22121"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M4.5 -5.30499e-07L4.5 0.642857C4.5 2.7731 6.2269 4.5 8.35714 4.5L9 4.5"
        id="Ellipse 22122"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

SparkleCurved.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

SparkleCurved.defaultProps = {
  className: '',
  style: {},
};

// Simple cross/plus sparkle - matches original SVG exactly
export const SparkleCross = ({ className, style }) => (
  <svg
    className={className}
    fill="none"
    height="100%"
    overflow="visible"
    preserveAspectRatio="none"
    style={{ display: 'block', ...style }}
    viewBox="0 0 4 4"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 2147205516">
      <line
        id="Line 28"
        stroke="currentColor"
        strokeWidth="1.5"
        x1="2.00586"
        x2="2.00586"
        y1="3.27841e-08"
        y2="4"
      />
      <line
        id="Line 29"
        stroke="currentColor"
        strokeWidth="1.5"
        x1="4"
        x2="-6.55671e-08"
        y1="2.01074"
        y2="2.01074"
      />
    </g>
  </svg>
);

SparkleCross.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

SparkleCross.defaultProps = {
  className: '',
  style: {},
};
